$('.mobile-collection .text-with-icon button').click(function () {
  $('.mobile-collection .collection__facets').slideToggle(300);
  $('.mobile-collection .text-with-icon button').toggleClass('opened');
  if ($('.mobile-collection .text-with-icon button').hasClass('opened')) {
    $('.mobile-collection>.text-with-icon').css('borderBottom', 'none');
  } else {
    setTimeout(() => {
      $('.mobile-collection >.text-with-icon').css('border-bottom', '1px solid rgba(0, 0, 0, 0.1)');
    }, 300);
  }
});

$('.facets__floating-filter>button').click(function() {
  $("#facets-drawer").find('.accordion').removeAttr('open');
})

$(window).on('load', function () {
  var pbadge = $("#product_badge");
  var reveiwsElem = pbadge.parent().find('.overlay-goshop-right b');
  var reviewsCount = pbadge.find('.jdgm-prev-badge').attr('data-number-of-reviews');
  var isProductReviews = pbadge.attr('product_reviews_number_enable');

  if(isProductReviews == 'true') {
    reviewsCount = reviewsCount || '100k+';    
    pbadge.hide();
    reveiwsElem.text(reviewsCount);
  }
  
  window.dispatchEvent(new Event('resize'));
})